import React, { useEffect, useState } from "react";
import { observer } from "mobx-react-lite";

import { Dropdown } from "../../../components/dropdown/Dropdown";
import { ProjectFormat } from "../../../services/project/ProjectFormat";
import FormField from "../../../components/form-field/FormField";
import { RequiredOptionValidatorModel } from "../../../services/form/validators/required/RequiredOptionValidator";

interface EditProjectFormatProps {
  value: ProjectFormat;
  formats: ProjectFormat[];
  onChange: (projectFormat: ProjectFormat) => void;
  setFieldValue: Function;
  disabled?: boolean;
}

export const EditProjectFormat = observer((props: EditProjectFormatProps) => {
  const { value, formats, onChange, setFieldValue, disabled } = props;
  const [requiredOptionValidator] = useState(() =>
    RequiredOptionValidatorModel.create({ option: value })
  );

  useEffect(() => {
    requiredOptionValidator.set(value);
  }, [requiredOptionValidator, value]);

  return (
    <FormField
      id="project-format"
      labelKey="general.project.format"
      fieldName="format"
      fieldValue={value}
      validator={requiredOptionValidator}
      required
      disabled={disabled}
      children={() => (
        <div className="form-element-container">
          <Dropdown
            selectedOption={value}
            options={formats}
            onChange={onChange}
            disabled={disabled}
            fieldName="format"
            setFieldValue={setFieldValue}
            placeholderKey="EditProject.format.selection"
          />
        </div>
      )}
      errorName="format"
    />
  );
});
